import { useEffect } from "react";
import Program from "../components/Program";
import Title from "../components/Title";
import Topic from "../components/Topic";
import ReturnTopButton from "../components/Returntopbutton";
import {
  Grid,
  GridItem,
  Box,
  VStack,
  Heading,
  Divider,
  Spacer,
} from "@chakra-ui/react";

export default function AbstractList() {

  useEffect(() => {
    document.title = "第79回TOP | 日本消化器画像診断研究会";
  }, []);
  
  return (
    <Grid
      maxW="900px"
      mx="auto"
      px={4}
      py={8}
      alignItems="start"
    >
      <GridItem mr={4}>
        <VStack align="stretch" spacing={6}>
          <Box>
            <Topic title="プログラム">
              <VStack align="stretch" spacing={4} mt={2}>
                <Program
                  title="9月19日（金）
口演会場"
                  today="1"
                />
                <Program
                  title="9月20日（土）
口演会場"
                  today="2"
                />
                <Program
                  title="9月20日（土）
ポスター会場"
                  today="3"
                />
              </VStack>
            </Topic>
          </Box>
        </VStack>
      </GridItem>

      
    </Grid>
  );
}
